module.exports = __webpack_public_path__ + "static/media/NAAC A+.f4ac2678.png";